import { LogOut } from 'lucide-react'
import { useContext } from 'react'
import { UserCard } from '~/components/new/app-ui/user-card'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu'
import { cn } from '~/lib/utils'
import { AuthContext } from '../../../utils/context/auth.context'

export function AppNavUser({
  className,
  dropdownSide,
  dropdownAlign,
}: {
  className?: string
  dropdownSide?: 'top' | 'right' | 'bottom' | 'left'
  dropdownAlign?: 'start' | 'center' | 'end'
}) {
  const { logout, user } = useContext(AuthContext)

  if (!user) {
    return null
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'h-fit justify-start px-2 rounded-xl cursor-pointer hover:bg-transparent',
          className,
        )}
      >
        <UserCard firstName={user.firstName} lastName={user.lastName} description={user.email} />
      </DropdownMenuTrigger>

      <DropdownMenuContent
        side={dropdownSide}
        align={dropdownAlign}
        className="rounded-lg min-w-56"
      >
        <DropdownMenuItem className="hover:text-primary-foreground">
          <UserCard firstName={user.firstName} lastName={user.lastName} description={user.email} />
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem variant="destructive" role="button" onClick={logout}>
          <LogOut />
          Déconnexion
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
